import ActivityManager from "../core/activityManager";

/**
 * Base class for activity entities with reference to the activity manager
 * @private
 */
export default class ActivityEntity {

  public _manager: ActivityManager;
  public _id: string;

  constructor(id: string) {
    this._id = id;
  }

  public get id(): string {
    return this._id;
  }

  /**
   * Updates the properties of the current object using the properties of another object
   * These two should have the same id.
   */
  public _update(other: ActivityEntity) {
    if (other._id !== this._id) {
      throw Error("Can not update from entity with different id.");
    }
    this._updateCore(other);
  }

  public _updateCore(other: ActivityEntity) {
    return;
  }

  public _beforeDelete(other: ActivityEntity) {
    return;
  }
}
